import React from 'react';
import {
  H3,
  HelplinePhoneNumber,
  Image,
  Paragraph,
  PhoneLink,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../../../../../core';
import {
  BillingStatement,
  PrescriptionLabel,
} from '../../../../../../../assets/images';
import { useScreenSize } from '@mchs/web-core';
import { MessageDialog } from '../../../../../../../core/components/dialogs/messageDialog';

export interface LearnMoreDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const calculateImageWidth = (screenWidth: number, buffer: number): number => {
  const imageWidth = screenWidth - buffer;
  const maxWidth = 500;

  return maxWidth < imageWidth ? maxWidth : imageWidth;
};

const calculateImageHeight = (
  imageWidth: number,
  imageRatio: number
): number => {
  return imageWidth / imageRatio;
};

const LearnMoreDialog: React.FC<LearnMoreDialogProps> = (
  props: LearnMoreDialogProps
) => {
  const screenSize = useScreenSize();

  const imageWidth = calculateImageWidth(screenSize.width, 30);

  return (
    <MessageDialog
      title="Where can I find my Medical Record Number (MRN)?"
      isOpen={props.isOpen}
      onDismiss={props.onClose}
    >
      <StackedColumn>
        <Paragraph text="Your MHN can be found on any medical record document and your billing statement." />
        <StackedColumn spacing={StackedColumnSpacing.NoGap}>
          <H3 text="Billing statement:" />
          <Paragraph text="Your MHN number is the first set of numbers listed before the dash in your account number." />
          <Image
            source={BillingStatement}
            width={imageWidth}
            height={calculateImageHeight(imageWidth, 580 / 221)}
            alternateText="Billing Statement"
          />
        </StackedColumn>
        <StackedColumn spacing={StackedColumnSpacing.NoGap}>
          <H3 text="Prescription label:" />
          <Paragraph text="Your MHN number may be listed on your prescription label." />
          <Image
            source={PrescriptionLabel}
            width={imageWidth}
            height={calculateImageHeight(imageWidth, 331 / 209)}
            alternateText="Prescription Label"
          />
        </StackedColumn>
        <StackedColumn spacing={StackedColumnSpacing.NoGap}>
          <H3 text="Ask us:" />
          <div>
            <Paragraph text="You can also ask a care team member or call " />
            <PhoneLink phoneNumber={HelplinePhoneNumber} includeImage={false} />
            <Paragraph text=" for your MRN." />
          </div>
        </StackedColumn>
      </StackedColumn>
    </MessageDialog>
  );
};

export default LearnMoreDialog;
